import _ from 'lodash';
import SectionCard from '../../molecule/SectionCard';
import SectionLabel from '../../molecule/SectionLabel';
import { DetailSctionRenderer } from './renderer';
import React from 'react';

export interface DetailSectionContent<Tdata> {
  key: string | string[];
  lable: string;
  isHidden?: boolean;
  render?: (value: string) => React.ReactNode;
  valueSetter?: (data: Tdata) => string;
}
interface DetailSectionProps<Tdata> {
  sectionTitle?: React.ReactNode;
  data: Tdata;
  contents: DetailSectionContent<Tdata>[][];
  bottomContents?: React.ReactNode;
  className?: string;
  defaultOpen?: boolean;
  isCollapsible?: boolean;
}

export default function DetailSection<Tdata>({
  sectionTitle,
  contents,
  data,
  bottomContents,
  className,
  defaultOpen = true,
  isCollapsible = false,
}: DetailSectionProps<Tdata>) {
  const renderSectionGridStyle = () => {
    let resultStyle = '';

    for (let i = 0; i < contents.length; i++) {
      if (i === contents.length - 1) {
        resultStyle += '1fr';
      } else {
        resultStyle += '1fr auto ';
      }
    }

    return resultStyle;
  };

  return (
    <SectionCard
      defaultOpen={defaultOpen}
      isCollapsible={isCollapsible}
      cardTitle={sectionTitle}
      className={className}
    >
      <div
        style={{ gridTemplateColumns: renderSectionGridStyle() }}
        className="grid gap-x-6 gap-y-6"
      >
        {contents.map((content, contentIdx) => (
          <React.Fragment key={contentIdx.toString()}>
            <div className="col-span-1 flex flex-col gap-y-6">
              {content.map((item, idx) => {
                if (item?.isHidden) return;
                const dataKey = item.key;

                let value = '-';
                if (typeof dataKey !== 'string') {
                  let temp: any = _.cloneDeep(data);
                  for (let i = 0; i < dataKey.length; i++) {
                    temp = temp?.[dataKey[i]] || '-';
                  }

                  value = temp as string;
                } else {
                  const valueTemp = data?.[item.key as keyof Tdata];
                  if (typeof valueTemp === 'string') {
                    value = valueTemp;
                  } else if (typeof valueTemp === 'number') {
                    value = valueTemp.toLocaleString();
                  }
                }

                if (item.valueSetter !== undefined) {
                  value = item.valueSetter(data);
                }

                return (
                  <SectionLabel
                    key={idx.toString()}
                    label={item.lable}
                    value={
                      item?.render
                        ? item.render(value)
                        : DetailSctionRenderer.TEXT()(value)
                    }
                  />
                );
              })}
            </div>
            {contentIdx !== contents.length - 1 && (
              <div className="border-r border-r-gray1" />
            )}
          </React.Fragment>
        ))}
        {bottomContents && <div className="col-span-3">{bottomContents}</div>}
      </div>
    </SectionCard>
  );
}
